export enum EUserUrls {
  PROFILE = 'profile',
  IMPERSONATION = 'impersonation',
  NOTES = 'notes',
}
